module.exports = __webpack_public_path__ + "img/journal.1f2846c9.svg";